import React, { Component } from 'react';
import MemberHeader from '../../components/MemberHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { Card, Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FormTemplate from '../../components/FormTemplate';
import { memberOperations } from '../Members/state';
import { SideNotification, profileImageStyle } from '../../../utils/common';
import { NOTIF_ERROR } from '../../../utils/constants';
import { MSG_DEFAULT_ERROR } from '../../../utils/messages';
import { Image as NativeImage } from 'react-native';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';

class PaymentScreen extends Component {
    state = {
        countries: [],
    }

    componentDidMount() {
        this.setState({
            countries:  this.props.listOfCountries()
        })
    }

    render() {
        return (
            <div>
                <MemberHeader />
                <ModuleContainer style={{ border: "1px solid #fff" }}>
                    {/* <center><h1>Payment Information</h1></center>
                    <hr /> */}
                    <Row>
                        <Col md={{ span: 4, offset: 1}}>
                            <Card >
                                <h2>Member Information</h2>
                                <NativeImage
                                    source={{ uri: `${REST_SERVICE_URL_ROOT}/user/image/1?${this.state.imageHash}` }}
                                    style={profileImageStyle}
                                    resizeMode={"cover"}
                                />
                                <br />
                                <p className="space-between-data"><b>Name: </b> John Doe</p>
                                <p className="space-between-data"><b>Gender: </b> Male</p>
                                <p className="space-between-data"><b>Batch Year: </b> 1998</p>
                                <p className="space-between-data"><b>Email Address: </b> test@test.com</p>
                                <p className="space-between-data"><b>Contact Number: </b> 000-0000</p>
                                <p className="space-between-data"><b>Company: </b> Company Name</p>
                                <p className="space-between-data"><b>Industry: </b> Science and Technology</p>
                                <p className="space-between-data"><b>Designation: </b> Worker</p>
                                <p><b>Company Description: </b>
                                <br/>Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                    accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                                    quae ab illo inventore veritatis et quasi architecto beatae
                                    vitae dicta sunt explicabo.</p>
                            </Card>
                        </Col>

                        <Col md={6}>
                            <Card>
                                <FormTemplate
                                    formClassName={"form-inline-display"}
                                    formInputs={this.props.formInputs}
                                    selectInput={this.state.countries}
                                    formButtons={[
                                        { variant: "success", label: "Pay Subscription", className: "pull-right", onClick: () => { alert("PAY SUBSCRIPTION") } }
                                    ]}
                                />
                            </Card>
                        </Col>
                    </Row>
                </ModuleContainer>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        formInputs: state.payments.paymentForm
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        listOfCountries: memberOperations.listOfCountries
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(PaymentScreen);
